import apiManager from './apiManager'
const getSingleApplication = async (
	pageNumber = 1,
	incidenceId,
	applicationId
) => {
	// {{url}}/v1/agent/application/5
	const singleApplication = apiManager.axios
		.get(
			`/v1/admin/incident/${incidenceId}/application/${applicationId}?page=${pageNumber}`
		)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return singleApplication
}

const approveApplication = async (incidenceId, applicationId) => {
	// {{url}}/v1/agent/application/5
	const application = apiManager.axios
		.patch(`/v1/admin/incident/${incidenceId}/application/${applicationId}`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return application
}
const changeApplication = async (incidenceId, applicationId, userId) => {
	const changeAgentApplication = apiManager.axios
		.put(
			`/v1/admin/incident/${incidenceId}/application?applicationId=${applicationId}&userId=${userId}`
		)
		.then((response) => {
			return {
				status: 200,
				data: response.data.data,
			}
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return changeAgentApplication
}
const assignVerifiedAgent = async (incidentId, agentId) => {
	const assignAgent = apiManager.axios
		.patch(`/v1/admin/incident/${incidentId}/agent/${agentId}`)
		.then((response) => {
			return {
				status: 200,
				data: response.data.data,
			}
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return assignAgent
}

export default {
	getSingleApplication,
	approveApplication,
	changeApplication,
	assignVerifiedAgent,
}
